var React = require('react');

function IconCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M957.7 512.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z"}));
}

IconCircleSolid.displayName = "IconCircleSolid";

IconCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCircleSolid;

IconCircleSolid.default = IconCircleSolid;
